import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import { print } from 'graphql';

const GRAPHQL_URL =
  typeof window === 'undefined'
    ? import.meta.env.VITE_GRAPHQL_URL
    : '/api/graphql';

export async function fetchGraphQL<TData, TVariables>(
  document: TypedDocumentNode<TData, TVariables>,
  variables?: TVariables,
  token?: string,
): Promise<TData | null> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const res = await fetch(GRAPHQL_URL, {
    method: 'POST',
    headers,
    body: JSON.stringify({ query: print(document), variables }),
  });

  if (!res.ok) return null;

  const json = await res.json();
  if (json.errors) return null;

  return json.data ?? null;
}
